import { Link } from 'react-router-dom'
import { Facebook, Ghost, Home, Instagram } from 'lucide-react'
import { motion } from 'framer-motion'
import { Button } from '../ui/button'
import { cn } from '@/lib/utils'
import { BUSINESS_MAIN_PAGE, BUSINESS_SOCIALS_FACEBOOK, BUSINESS_SOCIALS_INSTAGRAM, LOYALTY_PROGRAMME_NAME, LOYALTY_PROGRAMME_TAG_LINE, LOYALTY_PROGRAMME_TAG_LINE_DESCRIPTION } from '@/Constants'
import { ASSETS } from '@/config'
import { FooterLinks } from '@/data'
import Footer from './Footer'

const NotFound = () => {

    // TODO: REMOVE add some loyalty related flair
    return (
        <div className="h-full w-full">
            <main className='min-h-screen h-full w-full bg-primary/75 flex flex-col items-center justify-center px-6'>
                <div className="w-full max-w-[1000px] rounded-xl shadow-2xl py-9 md:py-12 bg-background flex flex-col items-center justify-center text-center gap-6">
                    <h1 className="text-4xl md:text-5xl font-bold mb-4 px-6 md:px-12">
                        Boo! You found a ghost.
                    </h1>
                    <div
                        className="w-64 h-64 md:w-[24rem] md:h-[24rem] rounded-full bg-primary relative overflow-hidden flex items-center justify-center"
                    >
                        <motion.div
                            animate={{
                                y: [0, -15, 0],
                                rotate: [0, 2, -2, 0],
                                scale: [1, 1.05, 1],
                            }}
                            transition={{
                                duration: 4,
                                repeat: Infinity,
                                ease: 'easeInOut',
                            }}
                            className="drop-shadow-[0_0_12px_hsl(var(--accent))]"
                        >
                            <Ghost size={100} className="md:w-[10rem] md:h-[10rem] text-secondary-color" />
                        </motion.div>
                    </div>
                    <div className="flex flex-col justify-center items-center gap-4 px-6 md:px-12">
                        <p className="text-lg text-primary-color/60 mb-8">
                            Looks like the page you are looking for doesn't exist.
                        </p>
                        <Button
                            className="w-full max-w-[200px] secondary-font"
                            onClick={() => { window.location.href = "/portal" }}
                        >
                            <Home className="h-6 w-6" />
                            Take Me Home
                        </Button>
                    </div>
                </div>
            </main>
            <div className='bg-primary'>
                <Footer
                    customFooter={
                        <div className="text-secondary px-12 py-6">
                            <div className="h-full w-full flex flex-col justify-center items-center gap-6 py-6">
                                <div className={cn(
                                    "h-full w-full flex flex-col items-center lg:flex-row justify-center gap-6",
                                    LOYALTY_PROGRAMME_TAG_LINE_DESCRIPTION ? "lg:gap-6 xl:gap-64" : "lg:gap-64"
                                )}
                                >
                                    <div
                                        className="w-[12rem] h-[12rem] rounded-full bg-secondary flex flex-col justify-center items-center p-6"
                                    >
                                        {BUSINESS_MAIN_PAGE ?
                                            <a
                                                href={BUSINESS_MAIN_PAGE}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img
                                                    className="hover:scale-105 transition-transform duration-300 object-contain"
                                                    src={ASSETS.CUSTOMER_LOGO}
                                                    alt="Organization Footer Logo"
                                                />
                                            </a>
                                            :
                                            <img
                                                className="object-contain"
                                                src={ASSETS.CUSTOMER_LOGO}
                                                alt="Organization Footer Logo"
                                            />
                                        }
                                    </div>
                                    <div className="text-2xl lg:text-5xl">
                                        {LOYALTY_PROGRAMME_NAME}
                                        {LOYALTY_PROGRAMME_TAG_LINE &&
                                            <div className='text-sm lg:text-xl pt-3 opacity-75'>
                                                <i>"{LOYALTY_PROGRAMME_TAG_LINE}"</i>
                                            </div>
                                        }
                                        {LOYALTY_PROGRAMME_TAG_LINE_DESCRIPTION &&
                                            <p className="pt-6 text-center lg:text-left text-lg max-w-2xl mx-auto opacity-90">
                                                {LOYALTY_PROGRAMME_TAG_LINE_DESCRIPTION}
                                            </p>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="border-t border-primary-foreground/20 pt-6">
                                <div className="flex flex-col gap-6 md:flex-row md:gap-0 justify-between items-center space-y-4 md:space-y-0">
                                    <div className="flex flex-col md:flex-row items-center gap-3 text-xs">
                                        {FooterLinks.map(fL =>
                                            <Link
                                                key={fL.id}
                                                className="hover:text-secondary/80"
                                                to={fL.to}
                                                rel="noopener noreferrer"
                                                target="_blank"
                                            >
                                                {fL.name}
                                            </Link>
                                        )}
                                    </div>
                                    {(BUSINESS_SOCIALS_FACEBOOK || BUSINESS_SOCIALS_INSTAGRAM) &&
                                        <div className="flex space-x-4">
                                            {BUSINESS_SOCIALS_INSTAGRAM &&
                                                <a
                                                    href={BUSINESS_SOCIALS_INSTAGRAM}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="hover:text-secondary/80"
                                                >
                                                    <Instagram className="w-5 h-5" />
                                                </a>
                                            }
                                            {BUSINESS_SOCIALS_FACEBOOK &&
                                                <a
                                                    href={BUSINESS_SOCIALS_FACEBOOK}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="hover:text-secondary/80"
                                                >
                                                    <Facebook className="w-5 h-5" />
                                                </a>
                                            }
                                        </div>
                                    }
                                </div>
                                <div className="text-center mt-8 text-sm opacity-75">
                                    <p>
                                        Powered by ShoutOUT (
                                        <a
                                            href="https://cxforge.com"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="hover:text-secondary/80 transition-opacity underline"
                                        >
                                            CXForge
                                        </a>
                                        )
                                    </p>
                                </div>
                            </div>
                        </div>
                    }
                />
            </div>
        </div>
    )
}

export default NotFound
